import { client } from "../client";

// AO2 JudgeState values, as carried by the JD packet.
export const JUDGE_POS_DEPENDENT = -1; // visibility follows the courtroom position
export const JUDGE_HIDE = 0; // server forces the controls hidden
export const JUDGE_SHOW = 1; // server forces the controls shown (e.g. while CM)

/**
 * Shows or hides the judge controls (witness testimony / cross-examination /
 * verdict). Mirrors AO2's show_judge_controls: a non-default judge_state from
 * the server overrides the position, so a CM keeps the controls regardless of
 * which character or position they switch to.
 */
export const showJudgeControls = (posIsJudge: boolean) => {
  let visible = posIsJudge;
  if (client.judgeState !== JUDGE_POS_DEPENDENT) {
    visible = client.judgeState === JUDGE_SHOW;
  }

  const judge = document.getElementById("judge_action");
  const noAction = document.getElementById("no_action");
  if (judge) judge.style.display = visible ? "inline-table" : "none";
  if (noAction) noAction.style.display = visible ? "none" : "inline-table";
};

/** Whether the currently selected role is the judge position. */
export const currentPosIsJudge = (): boolean => {
  const roleSelect = document.getElementById(
    "role_select",
  ) as HTMLSelectElement | null;
  return roleSelect?.value === "jud";
};
